import React, {useState, useEffect} from "react";
import { addProducts } from "../../api/products";
import { addUnit, getUNits } from "../../api/unit";

import "../../assets/css/table.css";

function TaskForm({ refresh, setRefresh }) {
  const [unitData, setUNitData] = useState([]);
  const [newuNit, setNewUnit] = useState(false);
   function handleVisibleNewUnit(event){
    event.preventDefault();
        setNewUnit(true);
   }
   function handleCancelNewUnit(event){
    event.preventDefault();
      setNewUnit(false);
   }

   const [unitName, setUNitName] = useState("");
    function handleUnitNameChange(e){
        setUNitName(e.target.value);
    }
      function getUnitLists(){
          getUNits((result) =>{
              if(result.ok === 1){
                 setUNitData(result.result);
              }else{
                alert("check your internet connection!");
              }
          })
      }

    function handleAddUNit(event){
       event.preventDefault();
         const unitData = {
            unitName
         }
           addUnit(unitData, (result) =>{
              if(result.ok === 1){
                setNewUnit(false);
                getUnitLists();
              }else{
                alert("check your internet connection");
              }

           })
    }

        const [product_name, setProduct_Name] = useState("");
        function handleChangeProductName(e){
           setProduct_Name(e.target.value);
        }

        const [prodUNit, setProdUNit] = useState("");
        function handleProdUnitChange(e){
           setProdUNit(e.target.value);
        }

        function handleAddProduct(event){
            event.preventDefault();
             if(product_name.length < 1){
                return alert("Product Name is required");
             }
             if(prodUNit.length < 1){
               return alert("Product Unit is required");
             }

             const productData = {
                 product_name,
                 prodUNit,
             };
            addProducts(productData, (result) =>{
                 if(result.ok === 1){
                  console.log(productData);
                    alert("Product added successfuly!");
                 }else{
                  console.log(productData);
                  console.log(result);
                    alert("check your internet connection");
                 }
            })
              
        }



     useEffect(() =>{
      getUnitLists();
     }, [unitData])




  return (
    <div
      className="d-flex justify-content-center align-items-center mt-4"
    >
      <div className="card p-4">
        <div className="card-body">
          <form method="post">
            <div className="form-group mb-3">
              <label>PRODUCT NAME</label>
              <input
                onChange={handleChangeProductName}
                type="text"
                className="form-control"
                placeholder="Product Name"
              />
            </div>
            <div className="form-group mb-3">
              <label>PRODUCT UNIT</label>
             <div className="row">
              <div className="col md-6">
              </div>
              {newuNit ? (
                <input className="form-control" placeholder="Unit Name" onChange={handleUnitNameChange}/>
              ):(
                <select onChange={handleProdUnitChange} className="form-control">
                <option>--Select Unit--</option>
                {unitData.map((item)=>(
                  <option>{item.name}</option>
                ))}
              </select>
              )}
              <div className="col md-6">
              {newuNit ? (
                <div className="mt-2">
                 <button className="btn btn-success btn-sm btn-float-left" onClick={handleAddUNit}>+add</button>
                 <button className="btn btn-danger btn-sm btn-float-left" onClick={handleCancelNewUnit}>cancel</button>
                </div>
              ): (
              <button className="btn btn-primary btn-sm btn-float-left" onClick={handleVisibleNewUnit}>+</button>
              )}
              
              
              </div>

             </div>
            </div>
            <div className="form-group mb-3">
             <button className="btn btn-primary" onClick={handleAddProduct}>Add Product</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default TaskForm;
